import React from "react"
import { render } from "storyblok-rich-text-react-renderer"
import RichText from "./richText"

const StaticItem = ({ blok }) => {
	return blok?.value
}

export default StaticItem
